export default {
    activeUser: {
        id: '',
        name: '',
        avatar: '',
        email: '',
        position_id: null,
        role: '',
        permissions: [],
        role: []
    },
    authentication: {
        type: '',
        token: '',
        refresh_token: ''
    }
}